// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/img/404.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".bg-cover[data-v-8c2502e6]{background-color:#eb226b;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.bg-cover h1 span[data-v-8c2502e6]{float:left;font-size:0}", ""]);
// Exports
module.exports = exports;
